import React, { useEffect, useState } from "react";
import styles from '../../styles/manage/manage.module.css';
import EditProfile from "./EditProfile";
import AddNewUser from "./AddNewUser";
import ListUsers from "./ListUsers";
import EditUsers from "./EditUsers";

export default function Manage() {
    const [activeTab, setActiveTab] = useState("editProfile");

    const tabs = [
        { key: "editProfile", label: "Edit Profile" },
        { key: "addUser", label: "Add New User" },
        { key: "listUsers", label: "List of Users" },
        { key: "editUser", label: "Edit Users" },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case "editProfile":
                return <EditProfile />;
            case "addUser":
                return <AddNewUser />;
            case "listUsers":
                return <ListUsers />;
            case "editUser":
                return <EditUsers />;
            default:
                return null;
        }
    };


    return (
        <main className="max-w-4xl mx-auto" onContextMenu={(e) => e.preventDefault()} id={styles.drawer} >
            <h1 className={`mb-2 text-center ${styles.mb3} ${styles.mt1}`}>Management Dashboard</h1>
            <div className={`d-flex flex-row flex-nowrap justify-space-even  ${styles.tabM}`}>
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        className={`px-5 py-2  ${styles.btnTab} ${activeTab === tab.key
                            ? `${styles.activeTab}`
                            : `${styles.inActiveTab}`
                            }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className={`bg-white rounded-lg shadow  ${styles.tabRender} `} >{renderContent()}</div>
        </main>
    );
}
